import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { OtherIndividualInfo } from '../../../domain/person';
import { RootState } from '../../../store';
import { continueApplicationProcessing } from '../../application/reducers/application';

type OtherIndividualsState = {
  individuals: OtherIndividualInfo[];
};

const initialState: OtherIndividualsState = {
  individuals: [],
};

const slice = createSlice({
  name: 'other-individuals',
  initialState,
  reducers: {
    saveOtherIndividual: (state, { payload: info }: PayloadAction<OtherIndividualInfo>) => {
      const existingIndex = state.individuals.findIndex(({ uiId }) => uiId === info.uiId);
      const updatedList =
        existingIndex >= 0
          ? state.individuals.map((item, index) => (index === existingIndex ? info : item))
          : [...state.individuals, info];

      return {
        ...state,
        individuals: updatedList,
      };
    },
    removeOtherIndividual: (state, action: PayloadAction<OtherIndividualInfo['uiId']>) => ({
      ...state,
      individuals: state.individuals.filter((p) => p.uiId !== action.payload),
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(
      continueApplicationProcessing,
      (
        state,
        {
          payload: {
            response: { application },
          },
        },
      ) => {
        if (application) {
          const nonApplicants: OtherIndividualInfo[] = (application.people ?? [])
            .filter(({ isApplicant }) => !isApplicant)
            .map((item) => {
              const { isApplicant: _isApplicant, authorizedRep: _authorizedRep, ...person } = item;
              return {
                ...person,
                uiId: '' + person.id,
                ssnLast4: person.ssnLast4 || '',
              };
            });

          return {
            ...state,
            individuals: nonApplicants,
          };
        } else return state;
      },
    );
  },
});

export default slice.reducer;
export const { saveOtherIndividual, removeOtherIndividual } = slice.actions;

export const selectOtherIndividuals = (state: RootState) => state.otherIndividuals.individuals;
